import React, { useState, useCallback, useMemo, useContext } from 'react';
import useTranslatedOptions from '@ubeya/shared/hooks/useTranslatedOptions';
import DropDown from '../../DropDown';
import CheckBox from '../../CheckBox';
import FilterLayout from '../FilterLayout';
import ConfigContext from '../../../contexts/ConfigContext';

const ADMIN_TYPE_OPTIONS = [
  {
    label: 'managerAdmin',
    value: 0
  },
  {
    label: 'branch_owner',
    value: 1
  },
  {
    label: 'account_owner',
    value: 2
  }
];

const AdminTypeFilter = ({ defaultValue, handleClose, onApply, search, onChange, hideLayout = false }) => {
  const { t } = useContext(ConfigContext);
  const adminOptions = useTranslatedOptions(ADMIN_TYPE_OPTIONS);
  const [values, setValues] = useState(defaultValue || []);

  const handleChange = useCallback(
    (value) => {
      const newValues = values.includes(value) ? values.filter((item) => item !== value) : [...values, value];
      setValues(newValues);
      onChange?.(newValues);
    },
    [onChange, values]
  );

  const filteredOptions = useMemo(
    () =>
      search
        ? adminOptions.filter(
            ({ label }) =>
              t('adminType').toLowerCase().includes(search.toLowerCase()) ||
              label.toLowerCase().includes(search.toLowerCase())
          )
        : adminOptions,
    [adminOptions, search, t]
  );

  if (!filteredOptions.length) {
    return null;
  }

  return (
    <FilterLayout
      name={t('adminType')}
      handleClose={handleClose}
      onApply={() => onApply(values)}
      hideLayout={hideLayout}>
      {filteredOptions.map(({ value, label }) => (
        <DropDown.Item key={value}>
          <CheckBox
            name={`admin-type-${value}`}
            value={values.includes(value)}
            label={label}
            onChange={() => handleChange(value)}
          />
        </DropDown.Item>
      ))}
    </FilterLayout>
  );
};

export default AdminTypeFilter;
